module.exports = __webpack_public_path__ + "bb.svg?15cb2720963727bf159655d4236736fa";